<p class="text-muted">Hello, <b>{{userInfo.firstName}} {{userInfo.lastName}}</b>
  From your My Account Dashboard you have the ability to view a snapshot of your recent account activity and update your
  account information. Select a link below to view or edit information.</p>

<div fxLayout="row wrap" class="flex-wrapper">
  <div fxFlex="33.3" fxFlex.sm="50" fxFlex.xs="100" class="col">
    <mat-card class="p-0">
      <mat-card-header class="p-1 account-card-title" fxLayoutAlign="space-between center">
        <mat-card-title class="m-0">
          <h3>Account Information</h3>
        </mat-card-title>
        <a mat-icon-button routerLink="/account/information">
          <mat-icon class="text-muted">edit</mat-icon>
        </a>
      </mat-card-header>
      <div class="divider"></div>
      <mat-card-content class="p-2 text-muted account-card-content">
        <p>{{userInfo.firstName}} {{userInfo.lastName}}</p>
        <p>{{userInfo.email}}</p>
        <p><a routerLink="/account/changepassword" class="primary-text">Change password</a></p>
      </mat-card-content>
    </mat-card>
  </div>
  <div fxFlex="33.3" fxFlex.sm="50" fxFlex.xs="100" class="col">
    <mat-card class="p-0">
      <mat-card-header class="p-1 account-card-title" fxLayoutAlign="space-between center">
        <mat-card-title class="m-0">
          <h3>Address</h3>
        </mat-card-title>
        <a mat-icon-button routerLink="/account/addresses">
          <mat-icon class="text-muted">edit</mat-icon>
        </a>
      </mat-card-header>
      <div class="divider"></div>
      <mat-card-content class="p-2 text-muted account-card-content">
        <p>Billing address</p>
        <p>Shipping address</p>
      </mat-card-content>
    </mat-card>
  </div>
  <div fxFlex="33.3" fxFlex.sm="100" fxFlex.xs="100" class="col">
    <mat-card class="p-0">
      <mat-card-header class="p-1 account-card-title" fxLayoutAlign="space-between center">
        <mat-card-title class="m-0">
          <h3>Orders</h3>
        </mat-card-title>
        <a mat-icon-button routerLink="/account/orders">
          <mat-icon class="text-muted">edit</mat-icon>
        </a>
      </mat-card-header>
      <div class="divider"></div>
      <mat-card-content class="p-2 text-muted account-card-content">
        <p class="">Completed</p>
        <mat-progress-bar value="75" color="primary"></mat-progress-bar>
        <p class="mt-1">Processing</p>
        <mat-progress-bar value="25" color="accent"></mat-progress-bar>
        <p class="mt-1">On hold</p>
        <mat-progress-bar value="65" color="warn"></mat-progress-bar>
        <p class="mt-1">Refunded</p>
        <mat-progress-bar value="25" color="primary"></mat-progress-bar>
      </mat-card-content>
    </mat-card>
  </div>
</div>